import React from "react";
import ProfileNavBar, {
  checkModuleCompleteness,
} from "../ProfileNavBar/ProfileNavBar";
import ProfileHeader from "../ProfileHeader/ProfileHeader";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";
import "./ProfileLayout.scss";
import {
  clientPartialDetailsToStore,
  ACreateApplicationTicket,
  setStageData,
  redirectToEntryPoint,
  completeModuleStatus,
  localStorageGetItem,
  localStorageSetItem,
} from "../../Services/globalService";
// import { useHistory } from "react-router-dom";
import { useNavigate, useNavigationType } from "react-router-dom";
import GlobalStore from "../../store/globalStore";
import {
  AGetEsignUrlDetails,
  APendingUploadList,
} from "../../Services/dashboard/eSignApiServices";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
import {
  containerUrl,
  dashboardUrl,
  leftNavBarArray,
  ipvNavBarObj,
  statusUrl,
} from "../../utils/constants";
import { ASendApplicationForQC } from "../../Services/dashboard/docVerificationAPIServices";
import { ACheckClientProfilingData } from "../../Services/dashboard/profilerApiServices";
import gtmService from "../../Services/gtmService";
import config from "../../../config/domain";
import { errorMessage } from "../../utils/errorMessage";
import moment from "moment";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";

export interface ProfileLayoutProps {
  children?: React.ReactNode
}

// The collapsible hamburger navbar takes over from the fixed desktop
// sidebar at and below this width - this covers what used to be the
// separate "tablet" and "mobile" breakpoints. Kept in sync with the
// `max-width: 1024px` rules in ProfileHeader.scss / ProfileLayout.scss.
const COLLAPSIBLE_NAV_MAX_WIDTH = 1024;

function isCollapsibleNavViewport() {
  return (
    typeof document !== "undefined" &&
    document.body.offsetWidth <= COLLAPSIBLE_NAV_MAX_WIDTH
  );
}

const ProfileLayout: React.FC<ProfileLayoutProps> = (props) => {
  clientPartialDetailsToStore();
  // const history = useHistory();
  const navigate = useNavigate()
  const navigationType = useNavigationType();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  let userId = 0;
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = parseInt(tokenMainObj?.UserId?.toString());
  }
  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);

  const [isCompactNav, setIsCompactNav] = React.useState<boolean>(
    isCollapsibleNavViewport
  );
  const isDesktop = !isCompactNav;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const mobileMenuButtonRef = React.useRef<HTMLButtonElement>(null);
  const mobileMenuId = React.useId();

  const closeMobileMenu = React.useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const toggleMobileMenu = React.useCallback(() => {
    setIsMobileMenuOpen((prev) => !prev);
  }, []);

  const mobileNavRef = useDialogA11y(isMobileMenuOpen, closeMobileMenu);

  // Keep the desktop/collapsible-nav split in sync with viewport and
  // browser-zoom changes (both fire a "resize" event), and with device
  // orientation changes, so the sidebar reliably reappears once the
  // effective viewport width goes back above 1024px (e.g. zooming out) and
  // the collapsible menu behaves correctly in portrait and landscape.
  React.useEffect(() => {
    function handleViewportChange() {
      setIsCompactNav(isCollapsibleNavViewport());
    }
    window.addEventListener("resize", handleViewportChange);
    window.addEventListener("orientationchange", handleViewportChange);
    return () => {
      window.removeEventListener("resize", handleViewportChange);
      window.removeEventListener("orientationchange", handleViewportChange);
    };
  }, []);

  // Auto-close the mobile menu (and never keep body scroll locked) once the
  // viewport is no longer compact-sized (e.g. the sidebar has reappeared).
  React.useEffect(() => {
    if (!isCompactNav && isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  }, [isCompactNav, isMobileMenuOpen]);

  // Prevent body scrolling while the mobile menu is open.
  React.useEffect(() => {
    if (!isMobileMenuOpen) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isMobileMenuOpen]);

  // Close the menu when clicking/tapping outside of it (and outside the
  // toggle button, which has its own click handler).
  React.useEffect(() => {
    if (!isMobileMenuOpen) return;
    function handleOutsideInteraction(e: MouseEvent | TouchEvent) {
      const target = e.target as Node;
      if (mobileNavRef.current?.contains(target)) return;
      if (mobileMenuButtonRef.current?.contains(target)) return;
      setIsMobileMenuOpen(false);
    }
    document.addEventListener("mousedown", handleOutsideInteraction);
    document.addEventListener("touchstart", handleOutsideInteraction);
    return () => {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("touchstart", handleOutsideInteraction);
    };
  }, [isMobileMenuOpen, mobileNavRef]);

  React.useEffect(() => {
    // if (history.action === "POP") {
    if (navigationType === "POP") {
      // history.push(redirectToEntryPoint());
      navigate(redirectToEntryPoint())
    } else if (
      !GlobalStore.isDigiLocker &&
      !GlobalStore.isKRA &&
      !GlobalStore.isKYC &&
      GlobalStore.leftNavBarState.length === leftNavBarArray.length &&
      GlobalStore?.stageStatus?.accountcategory !== 2
    ) {
      if (userId === 0) {
        GlobalStore.setLeftNavBarState((prevState) => [
          ...prevState,
          ipvNavBarObj,
        ]);
      }
    }
  }, [GlobalStore.isKYC, GlobalStore.isKRA]);

  React.useEffect(() => {
    setIsLoading(true);

    APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
  }, [window.location.pathname]);

  function checkPendingUpload(res: any) {
    if (!res || res.error) {
    } else {
      if (res && res.data) {
        const list: Array<any> = JSON.parse(res.data).filter(
          (item: any) =>
            // Prev Api response
            // item.documentcategoryid !== 36 &&
            // item.documentcategoryid !== 30 &&
            // item.documentcategoryid !== 62
            item.Mandatory == true
        );
        let isUploadDocumentsCompleted: boolean = false,
          isDematAccountFound: any = undefined,
          addressAccountFoundLocal: any = undefined;
        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length === 1
        ) {
          addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          let listObjFound = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          isDematAccountFound = listObjFound;
          if (listObjFound !== null && listObjFound !== undefined) {
            setDematAccountFound(listObjFound);
            // isUploadDocumentsCompleted = true;
          }
        }
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length > 1
        ) {
          let listObjFound = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          isDematAccountFound = listObjFound;
          setDematAccountFound(listObjFound);
          //    isUploadDocumentsCompleted = true;
        }
        ACheckClientProfilingData(
          getProfilerStatus,
          GlobalStore.applicationID,
          config.ClientProfilingDataSourseId
        );
        AGetStageCompletionStatus(
          (res: any) =>
            getClientStageDetails(
              res,
              isUploadDocumentsCompleted,
              isDematAccountFound,
              addressAccountFoundLocal
            ),
          GlobalStore.applicationID
        );
      } else if (res?.data == null) {
        ACheckClientProfilingData(
          getProfilerStatus,
          GlobalStore.applicationID,
          config.ClientProfilingDataSourseId
        );
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res, false),
          GlobalStore.applicationID
        );
      } else {
        setIsLoading(false);
      }
    }
  }

  function getProfilerStatus(res: any) {
    if (res.data) {
      completeModuleStatus(dashboardUrl.profiler);
    }
  }

  function getClientStageDetails(
    res: any,
    isUploadDocumentsCompleted: boolean,
    isDematAccountFound?: boolean,
    addressAccountFoundLocal?: any
  ) {
    if (!res || res.error) {
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        //set stage api data to GlobalStore

        GlobalStore.personaldetails.fsfullName = GlobalStore.personaldetails
          .fsfullName
          ? GlobalStore.personaldetails.fsfullName
          : responseObj?.fatherspousename;
        // GlobalStore.leftNavBarState = GlobalStore.leftNavBarState?.filter(
        //   (res) =>
        //     responseObj?.accountcategory !== 2 &&
        //     res.navUrl == dashboardUrl.plan
        // );
        const clientPartialDetails_ao = JSON.parse(
          localStorageGetItem("clientPartialDetails_ao") || "{}"
        );
        GlobalStore.pennyDropCount = responseObj.pennydropcount;
        clientPartialDetails_ao.pennyDropCount = responseObj.pennydropcount;


        if (!clientPartialDetails_ao.mobile) {
          clientPartialDetails_ao.mobile = responseObj.mobileno;
        }
        if (
          responseObj.iskra !== null &&
          responseObj.iskra !== undefined &&
          responseObj.iskra
        ) {
          GlobalStore.isKRA = responseObj.iskra;
        }
        if (!clientPartialDetails_ao.emailID) {
          clientPartialDetails_ao.emailID = responseObj.emailid;
        }
        if (
          responseObj?.dob !== null &&
          responseObj?.dob !== undefined &&
          responseObj?.dob !== ""
        ) {
          clientPartialDetails_ao.dob = moment(responseObj?.dob).format(
            "MM/DD/YYYY"
          );
          GlobalStore.birthDate = moment(responseObj?.dob).format("MM/DD/YYYY");
        }

        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        clientPartialDetails_ao.dpid = responseObj?.dpid;
        clientPartialDetails_ao.clientid = responseObj?.dpclientid;
        GlobalStore.dpid = responseObj?.dpid;
        GlobalStore.clientid = responseObj?.dpclientid;
        localStorageSetItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );

        setStageData(responseObj);

        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          isDematAccountFound,
          addressAccountFoundLocal
        );

        if (responseObj.isdigilockercompleted) GlobalStore.isDigiLocker = true;
        //route according to stage api response
        if (
          (!responseObj.isdigilockercompleted &&
            GlobalStore.aadharLinkedChoice &&
            !GlobalStore.isDigiLocker) ||
          responseObj.iskyc === null ||
          responseObj.iskra === null
        )
          GlobalStore.nextIncompleteStage = containerUrl.dgLocker;
        else if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        else if (!responseObj.isbankdetailscompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        else if (
          responseObj?.accountcategory === 2 &&
          !responseObj?.isdpcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (
          responseObj?.accountcategory !== 2 &&
          (!responseObj.isbrokeragesegmentcompleted ||
            !responseObj.isbrokerageschemecompleted)
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.plan;
        else if (!isUploadDocumentsCompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA &&
          !GlobalStore.isKYC &&
          !responseObj.isipvarificationcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.ipv;
        else if (responseObj.isagentvisitcompleted)
          GlobalStore.nextIncompleteStage = containerUrl.ocv;
        else if (!responseObj.isesigncompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.eSign;
        else if (
          (responseObj.applicationstatus === 0 ||
            responseObj.bpm_pd_status === 2 ||
            responseObj.bpm_pd_status === 3) &&
          responseObj.isprofiledetailscompleted &&
          responseObj.ispersonaldetailscompleted &&
          responseObj.isbankdetailscompleted &&
          responseObj.isbrokerageschemecompleted &&
          isUploadDocumentsCompleted &&
          (GlobalStore.isDigiLocker ||
            GlobalStore.isKRA ||
            GlobalStore.isKYC ||
            responseObj.isipvarificationcompleted)
        ) {
          AGetEsignUrlDetails(
            getEsignUrl,
            GlobalStore.applicationID,
            1,
            GlobalStore.stageStatus.accountcategory
              ? GlobalStore?.stageStatus?.accountcategory
              : 0,
            GlobalStore?.personaldetails?.pan
          );
        } else GlobalStore.nextIncompleteStage = containerUrl.poa;
      }
    }
    setIsLoading(false);
  }

  function getEsignUrl(res: any) {
    if (!res || res.error) {
      setIsLoading(false);
    } else {
      if (res.data.Data) {
        if (res.data.Data.ConvertToPhysical === true)
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
      } else {
        setIsLoading(false);
      }
    }
  }

  function createApplicationTicket(e?: any) {
    var message = "not refreshed";

    if ((window as any).refreshKeyPressed) {
      message = "refreshed";
    }

    if (message !== "refreshed") {
      const stageInfoId: number = parseInt(
        window.sessionStorage.getItem("stageInfoId") || ""
      );
      if (
        stageInfoId &&
        (stageInfoId === 1 ||
          stageInfoId === 2 ||
          stageInfoId === 5 ||
          stageInfoId === 6 ||
          stageInfoId === 7 ||
          stageInfoId === 9 ||
          stageInfoId === 10)
      ) {
        const appIdlocalStorage = JSON.parse(
          localStorageGetItem("clientPartialDetails_ao") || "{}"
        );

        let applicationId = "";
        let clientPrimaryDetailId = "";
        if (
          GlobalStore.applicationID != undefined ||
          GlobalStore.applicationID != ""
        ) {
          applicationId = GlobalStore.applicationID;
        } else if (
          appIdlocalStorage.applicationId != "" ||
          appIdlocalStorage.applicationId != undefined
        ) {
          applicationId = appIdlocalStorage.applicationId;
        }

        if (
          GlobalStore.clientPrimaryDetailId != undefined ||
          GlobalStore.clientPrimaryDetailId != ""
        ) {
          clientPrimaryDetailId = GlobalStore.clientPrimaryDetailId;
        } else if (
          appIdlocalStorage.clientPrimaryDetailId != "" ||
          appIdlocalStorage.clientPrimaryDetailId != undefined
        ) {
          clientPrimaryDetailId = appIdlocalStorage.clientPrimaryDetailId;
        }
        const stageInfoObj = {
          applicationid: applicationId,
          clientprimarydetailid: parseInt(clientPrimaryDetailId),
          stageinfoid: stageInfoId,
        };
        //   ACreateApplicationTicket(() => {}, stageInfoObj);
        e.returnValue = message;
        return message;
      }
    }

    // e.preventDefault();
    // window.alert("closing the window")
    // e.returnValue = '';
    // const stageInfoId: number = parseInt(window.sessionStorage.getItem('stageInfoId') || '');
    // if (
    //     stageInfoId &&
    //     (stageInfoId === 1 ||
    //         stageInfoId === 2 ||
    //         stageInfoId === 5 ||
    //         stageInfoId === 6 ||
    //         stageInfoId === 7 ||
    //         stageInfoId === 9 ||
    //         stageInfoId === 10)
    // ) {
    //     const stageInfoObj = {
    //         applicationid: GlobalStore.applicationID,
    //         clientprimarydetailid: parseInt(GlobalStore.clientPrimaryDetailId),
    //         stageinfoid: stageInfoId,
    //     };

    //     ACreateApplicationTicket(() => { }, stageInfoObj);
    // }
  }

  window.onbeforeunload = createApplicationTicket;

  //check for Navigation Timing API support
  if (window.performance) {
    console.info("window.performance works fine on this browser");
  }

  return (
    <div
      className={
        "prflLayout" +
        (isCompactNav && isMobileMenuOpen ? " mobileMenuOpen" : "")
      }
    >
      <header>
        <ProfileHeader
          isMobileMenuOpen={isCompactNav && isMobileMenuOpen}
          onToggleMobileMenu={toggleMobileMenu}
          mobileMenuId={mobileMenuId}
          mobileMenuButtonRef={mobileMenuButtonRef}
        />
      </header>
      <div className="prflBox">
        <nav
          id={mobileMenuId}
          ref={mobileNavRef}
          className={"prflLayoutBar" + (isMobileMenuOpen ? " open" : "")}
          aria-label={
            isDesktop
              ? "Sidebar application navigation"
              : "Mobile application navigation"
          }
          aria-hidden={isCompactNav ? !isMobileMenuOpen : undefined}
        >
          <ProfileNavBar
            isLoading={isLoading}
            onItemSelect={isCompactNav ? closeMobileMenu : undefined}
          />
        </nav>
        <main
          className={
            "prflLayoutForm" +
            (GlobalStore.stageStatus.applicationstatus === 1 &&
              GlobalStore.stageStatus.bpm_pd_status !== 2 &&
              window.location.pathname !== dashboardUrl.profiler &&
              window.location.pathname !== dashboardUrl.eSign
              ? " readOnly"
              : "")
          }
        >
          {props.children}
        </main>
      </div>
    </div>
  );
};

export default ProfileLayout;
